module.exports = __webpack_public_path__ + "media/bootstrap-icons/wifi-a122e9aa.svg";